export * from './contentful-link'
